import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function fetchMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function exchangeGoogleSession(sessionId) {
  const { data } = await api.post("/auth/google-session", null, {
    headers: { "X-Session-ID": sessionId },
  });
  return data;
}

export async function requestSms(phone) {
  const { data } = await api.post("/auth/sms-request", { phone });
  return data;
}

export async function emailLogin(email, password) {
  const { data } = await api.post("/auth/email-login", { email, password });
  return data;
}

export async function verifyOtp(pendingToken, code) {
  const { data } = await api.post("/auth/verify-otp", {
    pending_token: pendingToken,
    code,
  });
  return data;
}

export async function logout() {
  await api.post("/auth/logout");
}

export async function logoutAll() {
  const { data } = await api.post("/auth/logout-all");
  return data;
}

export async function fetchCompanies(params) {
  const { data } = await api.get("/companies", { params });
  return data;
}

export async function triggerRefresh(lookbackDays) {
  const { data } = await api.post(
    "/companies/refresh",
    null,
    { params: lookbackDays ? { lookback_days: lookbackDays } : {} }
  );
  return data;
}

export async function fetchStatus() {
  const { data } = await api.get("/refresh-status");
  return data;
}

export function exportUrl(params) {
  const usp = new URLSearchParams(params);
  return `${API}/companies/export?${usp.toString()}`;
}
